import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

export interface TextSearchProps {
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  debounce?: number; // optional debounce time (ms)
}

export const TextSearch: React.FC<TextSearchProps> = ({
  label = 'Search',
  placeholder = 'Enter keyword...',
  value,
  onChange,
  debounce = 300,
}) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (internalValue !== value) onChange(internalValue);
    }, debounce);
    return () => clearTimeout(handler);
  }, [internalValue, debounce]);

  return (
    <TextField
      fullWidth
      label={label}
      placeholder={placeholder}
      value={internalValue}
      onChange={e => setInternalValue(e.target.value)}
      size='medium'
      variant='outlined'
      sx={{
        '& .MuiInputBase-input': {
          fontSize: '0.85rem',
        },
        '& .MuiInputBase-root': {
          borderRadius: 1.5,
        },
        '& .MuiInputLabel-root': {
          fontSize: '0.85rem',
          '&:not(.Mui-focused)': {
            transform: 'translate(14px, 12px)',
          }
        },
        '& .MuiOutlinedInput-root': {
          height: '100%',
          alignItems: 'center',
        },
        '& .MuiOutlinedInput-input': {
          padding: '8px 12px',
          transform: 'translateY(0.5px)',
        },
      }}
    />
  );
};
